import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router';
import * as PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import { Login } from '../../../constant';
import authStorage from '../../../storages/mobx/authStorage';

class ClassicLoginButton extends React.Component {
  // onSuccessLogin = () => this.props.history.push('/app');

  render() {
    const { t } = this.props;
    return (
      <div className="form-group form-row mt-3 mb-0">
        <button
          className="btn btn-primary btn-block"
          type="button"
          onClick={() => authStorage.loginWithEmailAndPassword(this.onSuccessLogin)}
        >
          {t('auth.LogIn')}
        </button>
      </div>
    );
  }
}

ClassicLoginButton.propTypes = { t: PropTypes.func.isRequired };

export default translate(withRouter(ClassicLoginButton));
